export function loadScript (src) {
  return new Promise(function(resolve, reject){
    const head = document.head
    const script = document.createElement('script')
    const onSuccess = function(){
      this.removeEventListener('load', onSuccess)
      resolve(script)
    }
    const onError = function (){
      this.removeEventListener('error', onError)
      reject(script)
    }
    script.addEventListener('load', onSuccess)
    script.addEventListener('error', onError)
    script.src = src
    head.appendChild(script)
  })
}
